// extracted by mini-css-extract-plugin
export default {"ratingLabel":"ratingLabel__lqVo3"};